export const YoutubePlaylist = ({ apiKey = "", playlistId = "", changeFirstVideo = false, changedVideoIndex = 0 }) => ({
  apiKey: apiKey,
  playlistId: playlistId,
  maxResults: 10,
  videos: [],
  selectedVideo: 0,
  playing: false,
  loading: true,
  error: false,
  errorMessage: '',
  init() {
    this.fetchPlaylist();
  },
  fetchPlaylist() {
    if (!this.apiKey || !this.playlistId) {
      console.error('Youtube playlist settings are missing');
      return;
    }

    const url =
      `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=${this.maxResults}&playlistId=${this.playlistId}&key=${this.apiKey}`;

    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          this.error = true;
          this.errorMessage = data.error.message;
          this.loading = false;
          return;
        }
        this.videos = data.items.map(item => {
          return {
            videoId: item.snippet?.resourceId?.videoId,
            title: item.snippet?.title,
            description: item.snippet?.description,
            thumbnail: item.snippet?.thumbnails?.default?.url,
            previewImage:  item.snippet?.thumbnails?.maxres?.url
              || item.snippet?.thumbnails?.standard?.url
              || item.snippet?.thumbnails?.high?.url
              || item.snippet?.thumbnails?.medium?.url
              || item.snippet?.thumbnails?.default?.url,
          };
        });
        this.videos = this.videos.reverse();
        if (changeFirstVideo) {
          const item = this.videos[changedVideoIndex];
          this.videos.splice(changedVideoIndex, 1);
          this.videos.unshift(item);
        }
        this.loading = false;
      })
      .catch((err) => {
        this.error = true;
        this.errorMessage = "Failed to fetch the playlist";
        this.loading = false;
      });
  },
  selectVideo(index) {
    this.selectedVideo = index;
    this.playing = false;
  },
  playVideo() {
    this.playing = true;
  },
});
